export default function CtaMijloc() {
  return (
    <section
      className="relative py-20 px-6 overflow-hidden"
      style={{ background: '#0f1419' }}
    >
      {/* Decorative teal glow */}
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] rounded-full pointer-events-none"
        style={{ background: 'radial-gradient(ellipse, rgba(78,205,196,0.14) 0%, transparent 70%)', filter: 'blur(40px)' }}
      />

      {/* Animated chart line decoration */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden opacity-10">
        <svg width="100%" height="100%" viewBox="0 0 1440 200" preserveAspectRatio="none">
          <polyline
            points="0,160 120,130 240,150 360,90 480,120 600,70 720,100 840,60 960,95 1080,45 1200,75 1320,40 1440,65"
            fill="none"
            stroke="#4ecdc4"
            strokeWidth="2"
          />
          <polyline
            points="0,180 120,165 240,175 360,140 480,155 600,120 720,145 840,110 960,130 1080,95 1200,120 1320,88 1440,110"
            fill="none"
            stroke="#c9a96e"
            strokeWidth="1.5"
          />
        </svg>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <span
          className="inline-block text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-5"
          style={{ background: 'rgba(78,205,196,0.15)', color: '#4ecdc4' }}
        >
          Platformă Reglementată · Execuție Rapidă
        </span>

        <h2
          className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-5 leading-tight"
          style={{ fontFamily: 'Playfair Display, serif' }}
        >
          Ești Pregătit să Tranzacționezi
          <br />
          <span style={{ color: '#4ecdc4' }}>pe Piețele Reale?</span>
        </h2>

        <p className="text-gray-400 text-lg mb-10 max-w-xl mx-auto leading-relaxed">
          Aplică tot ce-ai învățat pe o platformă profesională. Înregistrare gratuită, fără comisioane ascunse.
        </p>

        {/* Stats row */}
        <div className="flex items-center justify-center gap-10 mb-10 flex-wrap">
          {[
            { value: '1:500', label: 'Levier Maxim' },
            { value: '0 pip', label: 'Spread de la' },
            { value: '24/5', label: 'Suport Live' },
          ].map((s, i) => (
            <div key={i} className="text-center">
              <div className="text-2xl font-bold text-white" style={{ fontFamily: 'Playfair Display, serif' }}>{s.value}</div>
              <div className="text-xs text-gray-500 mt-1">{s.label}</div>
            </div>
          ))}
        </div>

        {/* CTA Button 2 */}
        <a
          href="https://clicks.affstrack.com/c?c=1197206&l=ja&p=1"
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="inline-flex items-center gap-6 px-20 py-10 rounded-3xl text-white font-semibold text-2xl whitespace-nowrap cursor-pointer"
          style={{
            background: '#0f1419',
            border: '2px solid rgba(78,205,196,0.4)',
            transition: 'transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease, background 0.22s ease',
          }}
          onMouseEnter={e => {
            const el = e.currentTarget as HTMLAnchorElement;
            el.style.transform = 'scale(1.04) translateY(-3px)';
            el.style.boxShadow = '0 18px 48px rgba(78,205,196,0.22)';
            el.style.borderColor = 'rgba(78,205,196,0.9)';
            el.style.background = '#1a2332';
          }}
          onMouseLeave={e => {
            const el = e.currentTarget as HTMLAnchorElement;
            el.style.transform = 'scale(1)';
            el.style.boxShadow = 'none';
            el.style.borderColor = 'rgba(78,205,196,0.4)';
            el.style.background = '#0f1419';
          }}
        >
          <div className="w-16 h-16 flex items-center justify-center rounded-full" style={{ background: 'rgba(78,205,196,0.18)' }}>
            <i className="ri-line-chart-line text-3xl" style={{ color: '#4ecdc4' }} />
          </div>
          <span>Începe să Tranzacționezi Acum</span>
          <i className="ri-external-link-line text-lg opacity-60" />
        </a>

        <p className="text-gray-600 text-xs mt-5">
          Tranzacționarea implică risc. Nu investi mai mult decât îți permiți să pierzi.
        </p>
      </div>
    </section>
  );
}
